// extracted by mini-css-extract-plugin
export default {"container":"PatientInfosContainer_container__KVqjn"};